import { MapperFactory } from "../../CommonFactories"

export const getDependantFieldNames = MapperFactory({
  "state": [],
  "schoolMode": ["state"],
  "schoolInput": ["state", "schoolMode"]
})
